<script setup>
const props = defineProps({
  message: {
    type: String,
    required: true,
  },
})
</script>

<template>
  <div class="equal-small-2 message">
    {{ props.message }}
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.message {
  background-color: $color-dark-04;
  border-radius: 12px;
  padding: 11px 20px 11px 20px;
  text-align: center;

  &--success {
    color: $color-success-01;
  }

  &--warning {
    color: $color-warning-01;
  }

  &--danger,
  &--error {
    color: $color-danger-01;
  }

  &--dark-bg {
    background-color: #0d0d0d;
  }

  &--danger-bg {
    background-color: $color-danger-02;
  }
}
</style>
